import Megatron from '@ibibo/megatron';
import {apiConfig, appConfig} from '@ibibo/hotels-config';

const prepareSmartEngageApiRequest = (params, config) => {
  let url = `${apiConfig.__MYPARTNER__}`;
  const {smartEngageApiConfig} = apiConfig;

  url += `/api/${smartEngageApiConfig.version}/smart_engage/get_smart_ads/?flavour=${
    appConfig.defaultFlavour
  }&context=${config.context}&status=${smartEngageApiConfig.status}&slots=${JSON.stringify(
    config.slots,
  )}&params=${[JSON.stringify(params)]}`;

  return url;
};

export const smartEngageBannerListApi = async ({
  params,
  config,
}: {
  params: Object;
  config: Object;
}) => {
  const url = prepareSmartEngageApiRequest(params, config);

  const response = await Megatron({
    name: 'smart engage api',
    type: 'GET',
    url,
    credentials: 'omit'
  });

  return response;
};
